import React from 'react'
import { useController, useFormContext } from 'react-hook-form'
import { DSInput } from '@zoe/ds-web'

export interface InputFieldProps extends React.ComponentProps<'input'> {
  label?: React.ReactNode
  name: string // needed for useController
}

export const InputField: React.FC<InputFieldProps> = ({ label, name, ...restProps }) => {
  const { field, fieldState } = useController({ name })
  const { trigger } = useFormContext()

  const onChangeValidation = async (value: string) => {
    field.onChange(value)
    await trigger()
  }

  const showError = (fieldState.isTouched || (field.value?.toString().length ?? 0) >= 2) && fieldState.error

  return (
    <DSInput
      id={restProps.id || name}
      label={typeof label === 'string' ? label : undefined}
      aria-label={typeof label !== 'string' ? (restProps.placeholder ?? name) : undefined}
      name={field.name}
      value={field.value ?? ''}
      onBlur={field.onBlur}
      onChange={onChangeValidation}
      placeholder={restProps.placeholder}
      type={restProps.type}
      testId={`${name}-input`}
      isInvalid={!!showError}
      errorMessage={showError ? fieldState.error?.message : undefined}
    />
  )
}
